import React, { useEffect, useRef, useState } from 'react';
import { Collapse } from '@mui/material';
import clsx from 'clsx';

import CommonIconButton from '../common-icon-button/CommonIconButton';
import { ICONS } from '../../icons';

import scss from './CollapsedMessage.module.scss';

function CollapsedMessage({ children }) {
  const [isOpened, setIsOpened] = useState(false);
  const [needsCollapse, setNeedsCollapse] = useState(false);
  const messageRef = useRef(null);

  const toggleOpen = () => {
    setIsOpened((prevState) => !prevState);
  };

  useEffect(() => {
    if (!messageRef.current) return;
    setNeedsCollapse(messageRef.current.scrollHeight > 86);
  }, []);

  return (
    <div className={scss.collapsedMessage}>
      <Collapse in={needsCollapse ? isOpened : true} collapsedSize={needsCollapse ? 85 : undefined}>
        <div
          ref={messageRef}
          onClick={toggleOpen}
          onKeyDown={toggleOpen}
          role='presentation'
          className={clsx(scss.textCell, needsCollapse && scss['textCell--pointer'])}>
          {children}
        </div>
      </Collapse>

      {needsCollapse && (
        <div className={scss.collapseWrapper}>
          <div className={scss.collapseFade} />
          <CommonIconButton
            icon={ICONS.CaretUp}
            onClick={toggleOpen}
            iconClassName={clsx(scss.collapseIcon, !isOpened && scss.iconDown)}
          />
        </div>
      )}
    </div>
  );
}

export default CollapsedMessage;
